import React, { useCallback, useState } from 'react';


type BaseAttriutes = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;
export type  INumberInputProps = BaseAttriutes & {
  value: number;
  decimals?: number;
  onChange?: (value: number) => void;
};

export const NumberInput: React.FC<INumberInputProps> = (props) => {
  const [editString, setEditString] = useState<string>();
  
  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      const newValStr = event.currentTarget.value;
      setEditString(newValStr);
      const newVal = parseFloat(newValStr);
      if(newVal !== props.value)
        props.onChange(newVal);
    }
  }, [props]);

  const onBlur = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    setEditString(undefined);
    if (props.onBlur)
      props.onBlur(event);
  }, [props]);

  return (
    <input {...props} type='number'
      value={editString === undefined ? (props.value || 0).toFixed(props.decimals === undefined ? 2 : props.decimals) : editString }
      disabled={props.disabled || props.onChange === undefined}
      onChange={onChange} onBlur={ onBlur } />
  );
};



export type  IScaledNumberInputProps = BaseAttriutes & {
  value: number;
  scale: number;
  decimals?: number;
  onScaleChange?: (value: number) => void;
};

export const ScaledNumberInput: React.FC<IScaledNumberInputProps> = (props) => {
  const { onScaleChange, value, scale, ...restProps } = props;


  const onChange = useCallback((newVal: number) => {
    if (onScaleChange && value !== 0) {
      const newScale = newVal / value;
      onScaleChange(newScale);
    }

  }, [onScaleChange, value]);

  return (
    <NumberInput {...restProps} disabled={restProps.disabled || onScaleChange === undefined} value={value * scale} onChange={onChange}/>
  );
}